<template>
	<div class="list">
		<div class="h">
			<myheader></myheader>
			<mynav @onsearch="onsearch"></mynav>
			<div class="commoditybox">
				<div class="searchbox" v-if="search">
					“<span>{{search}}</span>”的搜索结果
				</div>
				<div class="sortbox">
					<div class="sort" ref="sort1" v-if="sortobj.brand &&sortobj.brand.length>0">
						<div :class="heightarr[0].status == 1 ? 'spans sl': 'spans'">
							<div class="stitle">品牌:</div>
							<span :class="v==brand?'checked':''" v-for="(v,k) in sortobj.brand" :key="k" @click="onlist(1,v)">{{v}}</span>
						</div>
						<el-button size="mini" class="ebtn" v-if="heightarr[0].num > 46" @click="onzk(0)">{{heightarr[0].status == 1 ? '展开': '收起'}}</el-button>
					</div>

					<div class="sort" ref="sort2" v-if="sortobj.cid_second &&sortobj.cid_second.length>0">
						<div :class="heightarr[1].status == 1 ? 'spans sl': 'spans'">
							<div class="stitle">分类:</div>
							<span :class="v==cid_second?'checked':''" v-for="(v,k) in sortobj.cid_second" :key="k" @click="onlist(2,v)">{{v}}</span>
						</div>
						<el-button size="mini" class="ebtn" v-if="heightarr[1].num > 46" @click="onzk(1)">{{heightarr[1].status == 1 ? '展开': '收起'}}</el-button>
					</div>

					<div class="sort" ref="sort3" v-if="sortobj.color &&sortobj.color.length>0">
						<div :class="heightarr[2].status == 1 ? 'spans sl': 'spans'">
							<div class="stitle">颜色:</div>
							<span :class="v==color?'checked':''" v-for="(v,k) in sortobj.color" :key="k" @click="onlist(3,v)">{{v}}</span>
						</div>
						<el-button size="mini" class="ebtn" v-if="heightarr[2].num > 46" @click="onzk(2)">{{heightarr[2].status == 1 ? '展开': '收起'}}</el-button>
					</div>

					<div class="sort" ref="sort4" v-if="sortobj.sex &&sortobj.sex.length>0">
						<div :class="heightarr[3].status == 1 ? 'spans sl': 'spans'">
							<div class="stitle">性别:</div>
							<span :class="v==sex?'checked':''" v-for="(v,k) in sortobj.sex" :key="k" @click="onlist(4,v)">{{v}}</span>
						</div>
						<el-button size="mini" class="ebtn" v-if="heightarr[3].num > 46" @click="onzk(3)">{{heightarr[3].status == 1 ? '展开': '收起'}}</el-button>
					</div>

				</div>
				<div class="filter">
					<div class="fbox finput">
						<span>折扣</span>
						<el-input type="number" v-model="bdiscount" placeholder="最低折扣" size="small" @blur="ondiscount">
						</el-input>
						<i>~</i>
						<el-input type="number" v-model="ediscount" placeholder="最高折扣" size="small" @blur="ondiscount">
						</el-input>
					</div>
					<div class="fbox">
						<el-select value="销量" size="small" @change="onselect">
							<el-option label="销量降序" value="1">
							</el-option>
							<el-option label="销量升序" value="2">
							</el-option>
						</el-select>
					</div>
					<div class="fbox">
						<el-select value="折扣" size="small" @change="onselect">
							<el-option label="折扣降序" value="3">
							</el-option>
							<el-option label="折扣升序" value="4">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="null" v-if="list.length == 0">
					<div class="img">
						<img src="../assets/image/null.png">
					</div>
					<div class="ps">
						<div class="h1">非常抱歉，没有找到相关商品。建议您：</div>
						<div class="p">1. 换个搜索词试试</div>
						<div class="p">2. 或联系客户经理提报您的找货需求</div>
					</div>
				</div>

				<div class="commoditys" v-if="list.length > 0">
					<div class="commodity" v-for="(v,k) in list" :key="k" @click="ondetail(v.id)">
						<div class="img">
							<img :src="onimgarr(v.pic)[0]" v-if="onimgarr(v.pic)[0]">
							<img v-else src="../assets/image/null.png">
						</div>
						<div class="name">{{v.brand}} {{v.sex}} {{v.cid_second}} {{v.cid_third}} {{v.style_number}}
						</div>
						<div class="pd">
							<div class="price">
								<span><i>￥</i>{{v.discount_price}}</span>起
							</div>
							<div class="discount" v-if="v.discount != 0">
								{{v.discount_str}}折起
							</div>
						</div>
						<div class="p">近30天成交{{v.buy_number_2week}}件</div>
						<div class="btndiv">
							<div class="btn">立即下单</div>
						</div>
					</div>
				</div>

				<div class="pagediv">
					<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50]" :current-page.sync="page"
						:page-size="pageSize" :total="total" v-if="total>0" @current-change="handleCurrentChange" @size-change="handleSizeChange">
					</el-pagination>
				</div>

			</div>
		</div>
		<myfooter></myfooter>
	</div>
</template>

<script>
	export default {
		name: 'List',
		data() {
			return {
				currentPage: 1,
				bdiscount: "",
				ediscount: "",
				search: this.$route.query.search,
				category: this.$route.query.category,
				order: this.$route.query.order,
				sortobj: {},
				keyword: "",

				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				heightarr: [{
					num: 0,
					show: false,
					status: 0
				}, {
					num: 0,
					show: false,
					status: 0
				}, {
					num: 0,
					show: false,
					status: 0
				}, {
					num: 0,
					show: false,
					status: 0
				}],
				brand: "",
				cid_second: "",
				color: "",
				sex: "",
			}
		},

		inject: ['onimgarr'],

		mounted() {
			this.onproductsearch();
			if(this.order) {
				this.onlist(5, 1);
			}else {
				this.onlist();
			}
			
		},

		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.onlist();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onsearch(val) {
				this.search = val;
				this.onproductsearch();
				this.page = 1;
				this.onlist();
			},

			onkeyword() {
				if (this.search) {
					return this.search;
				}

				if (this.category) {
					return this.category;
				}
			},

			onproductsearch() {
				var obj = {
					keyword: this.onkeyword()
				};
				this.$axios.post('api/product/search', obj).then(res => {
					if (res.data.code == 0) {
						this.sortobj = res.data.data;
						this.brand = "";
						this.cid_second = "";
						this.color = "";
						this.sex = "";
						this.heightarr.forEach((v,k)=>{
							v.num = 0;
							v.show = false;
							v.status = 0;
						})
						
						this.$nextTick(() => {
							this.onsort();
						});

					}
				}).catch(err => {
					console.log(err)
				})
			},

			ondiscount() {
				if (this.bdiscount && this.ediscount) {
					this.onlist(6);
				}
			},

			onxl(val) {
				console.log(val);
			},

			onselect(val) {
				this.onlist(5, val);
			},

			onlist(n, v) {
				if (n) {
					this.page = 1;
				}
				
				if (n == 1) {
					this.brand = v;
				}
				
				if (n == 2) {
					this.cid_second = v;
				}
				
				if (n == 3) {
					this.color = v;
				}
				
				if (n == 4) {
					this.sex = v;
				}
				
				var obj = {
					id: "",
					keyword: this.onkeyword(),
					brand: n == 1 ? v : this.brand,
					cid_second: n == 2 ? v : this.cid_second,
					color: n == 3 ? v : this.color,
					sex: n == 4 ? v : this.sex,
					bdiscount: this.bdiscount,
					ediscount: this.ediscount,
					order_type: n == 5 ? v : '',
					page: this.page,
					limit: this.pageSize
				};
				this.$axios.post('api/product/list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
						this.bdiscount = "";
						this.ediscount = "";
					}
				}).catch(err => {
					console.log(err)
				})
			},

			ondetail(val) {
				const url = this.$router.resolve({
					path: '/detail',
					query: {
						id: val
					}
				});
				window.open(url.href, "_blank");
			},

			onsort() {
				for (var i = 1; i <= 4; i++) {
					if (this.$refs['sort' + i]) {
						this.heightarr[i - 1].num = this.$refs['sort' + i].clientHeight;
						this.heightarr[i - 1].status = 1;
					} else {
						this.heightarr[i - 1].num = 0;
					}
				}
			},
			
			onzk(i) {
				if(this.heightarr[i].status == 0) {
					this.heightarr[i].status = 1
				}else {
					this.heightarr[i].status = 0;
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.h {
		min-height: calc(100vh - 60px);
	}

	.commoditybox {
		width: 1200px;
		border-radius: 10px;
		background-color: #fff;
		margin: 10px auto 30px;
		padding: 20px;
		box-sizing: border-box;
		
		.searchbox {
			color: #111;
			font-weight: 600;
			font-size: 14px;
			margin-bottom: 20px;

			span {
				color: #ff4714;
				font-weight: 600;
			}
		}

		.sortbox {
			width: 100%;

			.sort {
				width: 100%;
				border-bottom: 1px solid #f0f0f0;
				display: flex;
				align-items: flex-start;

				.spans {
					width: calc(100% - 60px);
					display: flex;
					flex-wrap: wrap;
					padding-top: 14px;
				}
				
				.sl {
					height: 32px;
					overflow: hidden;
				}

				.stitle {
					color: #111;
					font-weight: 600;
					font-size: 12px;
					padding-right: 10px;
					padding-bottom: 14px;
				}

				span {
					color: #333;
					cursor: pointer;
					margin-right: 24px;
					padding-bottom: 14px;
				}

				span:hover {
					color: #ff4714;
				}

				.ebtn {
					margin-top: 8px;
				}
				
				.checked {
					color: #ff4714;
				}
			}
		}


		.filter {
			width: 100%;
			display: flex;
			justify-content: flex-end;
			margin-top: 20px;
		}

		.fbox {
			width: 80px;
			margin-left: 8px;
		}

		.finput {
			width: 230px;
			display: flex;
			align-items: center;

			span {
				width: 80px;
			}

			i {
				padding: 0 6px;
			}
		}

		.null {
			width: 100%;
			height: 220px;
			display: flex;
			align-items: center;
			justify-content: center;

			.img {
				width: 172px;
				height: 107px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.ps {
				margin-left: 40px;
				text-align: left;
				font-weight: 500;

				.h1 {
					font-size: 18px;
					line-height: 24px;
					margin-bottom: 12px;
					color: #111;
				}

				.p {
					font-size: 14px;
					line-height: 18px;
					color: #111;
				}
			}
		}

		.commoditys {
			padding-top: 14px;
			box-sizing: border-box;
			display: flex;
			flex-wrap: wrap;

			.commodity {
				width: 216px;
				height: 329px;
				box-sizing: border-box;
				border-radius: 12px;
				padding: 4px;
				border: 1px solid transparent;
				margin-bottom: 20px;
				margin-right: 20px;
				cursor: pointer;
				position: relative;

				.img {
					width: 206px;
					height: 206px;
					border-radius: 10px;
					overflow: hidden;
					margin-bottom: 6px;

					img {
						width: 100%;
						height: 100%;
					}

					img:hover {
						transform: scale(1.1);
					}
				}

				.name {
					display: -webkit-box;
					font-size: 15px;
					font-weight: 500;
					height: 44px;
					line-height: 22px;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					margin-bottom: 4px;
					overflow: hidden;
					text-overflow: ellipsis;
					word-break: break-all;
					padding: 0 6px;
					box-sizing: border-box;
					text-align: justify;
				}

				.pd {
					display: flex;
					align-items: center;
					padding: 0 6px;
					box-sizing: border-box;
					margin-bottom: 1px;

					.price {
						font-size: 12px;
						line-height: 24px;
						color: #333;

						span {
							color: #ff4714;
							font-size: 20px;
							margin-right: 4px;
						}

						i {
							font-size: 12px;
						}
					}

					.discount {
						background-color: #ffede8;
						border-radius: 4px;
						color: #ff4714;
						font-weight: 500;
						height: 21px;
						line-height: 21px;
						margin-left: auto;
						padding: 0 6px;
					}
				}

				.p {
					height: 24px;
					line-height: 24px;
					color: #999;
					font-size: 12px;
					padding: 0 6px;
					box-sizing: border-box;
				}

				.btndiv {
					width: 100%;
					position: absolute;
					left: 0;
					top: 168px;
					display: flex;
					justify-content: center;

					.btn {
						width: 90px;
						height: 28px;
						background-color: #ffeeea;
						color: #ff4714;
						border-radius: 15px;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 14px;
						display: none;
					}

					.btn:hover {
						background-color: #ff4714;
						color: #fff;
					}
				}

			}

			.commodity:hover {
				border-color: #ff4714;

				.btn {
					display: flex;
				}
			}

			.commodity:nth-child(5n) {
				margin-right: 0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/list.vue